// src/AppWithRedirect.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setRedirectFn } from './RedirectManager';
import App from './App';

const AppWithRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setRedirectFn(navigate);
  }, [navigate]);

  return <App />;
};

export default AppWithRedirect;